import { render, staticRenderFns } from "./Fire.vue?vue&type=template&id=1ec1c627&scoped=true&lang=pug&"
import script from "./Fire.ts?vue&type=script&lang=ts&"
export * from "./Fire.ts?vue&type=script&lang=ts&"
import style0 from "./Fire.vue?vue&type=style&index=0&id=1ec1c627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec1c627",
  null
  
)

export default component.exports